/* @ngInject */
const newWagon = (

) => {
  const self = {}

  self.classic = () => {
    return {
      id: null,
      type: null,
      set: null,
      ownerId: null,
      length: null,
      tare: null,
      capacity: null,
      feet: null,
      brakedMass: null,
      color: null,
      status: null,
      state: null,
      client: null,
      extendRevision: 0,
      dispositions: [],
    }
  }

  self.search = () => {
    return {
      id: null,
      idOperator: '!',
      type: null,
      typeOperator: '=',
      typeNull: 'any',
      set: null,
      setOperator: '=',
      setNull: 'any',
      ownerId: null,
      railwayIdNull: 'full',
      length: null,
      lengthOperator: '=',
      lengthNull: 'any',
      tare: null,
      tareOperator: '=',
      tareNull: 'any',
      capacity: null,
      capacityOperator: '=',
      capacityNull: 'any',
      feet: null,
      feetOperator: '=',
      feetNull: 'any',
      brakedMass: null,
      brakedMassOperator: '=',
      brakedMassNull: 'any',
      color: null,
      colorOperator: '=',
      colorNull: 'any',
      case: null,
      caseOperator: '=',
      caseNull: 'any',
      status: null,
      statusOperator: '=',
      statusNull: 'any',
      state: null,
      stateOperator: '=',
      stateNull: 'any',
      archive: null,
      archiveOperator: '=',
      archiveNull: 'any',
      client: null,
      clientOperator: '=',
      clientNull: 'any',
      extendRevision: null,
      dispositions: [],
      trainArrival: null,
    }
  }

  return self
}

export default newWagon



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/new.service.js